import styled from 'styled-components';
import { theme } from '@jadwalh/ui';

export const UpdateWorkflowWrapper = styled.div`
  display: Flex;
  gap: 24px;
  width: 100%;
  justify-content: center;
  @media (max-width: 900px) {
    padding: 0px 12px 16px;
  }
  .rightSection {
    width: 600px;
    min-width: 600px;
    @media (min-width: 900px) and (max-width: 1199.5px) {
      width: 600px;
      min-width: 600px;
    }

    @media (max-width: 900px) {
      width: 100%;
      min-width: 100%;
    }
    button {
      &:disabled {
        border-color: transparent;
        background-color: #cdcdd7 !important;
        color: #ffffff !important;
        cursor: not-allowed;
        background-image: none;
        pointer-events: none;
      }
    }
  }
  .leftSection {
    width: 293px;
    min-width: 293px;
    height: 198px;
    @media (min-width: 900px) and (max-width: 1199.5px) {
      width: 600px;
      min-width: 600px;
    }

    @media (max-width: 900px) {
      width: 100%;
      min-width: 100%;
      height: unset;
    }
  }
  .save-form-btn,
  .cancel-form-btn {
    @media (max-width: 768px) {
      width: 50% !important;
    }
  }
  .mantine-Select-root input {
    line-height: 22px !important;
  }
`;

export const EventsWrapper = styled.div`
  padding-top: 16px;
  padding-right: 24px;
  padding-left: 24px;
  padding-bottom: 16px;
  @media (max-width: 767px) {
    padding: 16px !important;
  }
  .hasError {
    input,
    .mantine-Select-input,
    .mantine-DateInput-input,
    textarea {
      border: 1px solid ${theme.colours.error} !important;
    }
  }
  .custom-radio-input {
    margin-bottom: 0 !important;
  }
  .mantine-Radio-inner {
  }
  .event-checkbox {
    label {
      display: flex;
      gap: 4px;
      align-items: center;
    }
  }

  .number_input_select_wrapper {
    .ErrorMessageStyle {
      display: none !important;
    }
    .input_number_select {
      input {
        border-left: none !important;
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
      }
      input.hasError {
        border: 0.5px solid ${theme.colours.error} !important;
      }
    }

    .hide_label {
      .mantine-Select-root .mantine-Select-rightSection:lang(ar) {
        &:lang(ar) {
          left: -4px !important;
        }
        &:lang(en) {
          right: -4px !important;
        }
      }

      input {
        background-color: #eeeeee;
        width: 73px;
        &:lang(ar) {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;

          border-right: 0;
        }
        &:lang(en) {
          border-bottom-left-radius: 0;
          border-top-left-radius: 0;
          border-left: 0;
        }
        &::placeholder {
          color: #000000 !important;
          opacity: 1 !important;
        }
      }
    }
    .input-wrapper {
      .label {
        p {
          display: none;
          @media (max-width: 768px) {
            display: block;
          }
        }
      }
    }
    label {
      p {
        opacity: 0;
        white-space: nowrap !important;
        @media (max-width: 990px) {
          margin-bottom: 27px;
        }
      }
    }
  }

  .mantine-Select-root input {
    line-height: 22px !important;
  }
  .mantine-Checkbox-body {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    .mantine-Checkbox-inner {
      width: 16px;
      height: 16px;

      input {
        width: 16px;
        height: 16px;

        &:checked {
          background-color: ${theme.colours.blackText};
          border-color: ${theme.colours.blackText};
        }
      }
    }
  }
`;

export const ProsedureWrappers = styled.div`
  padding-top: 16px;
  padding-right: 24px;
  padding-left: 24px;
  padding-bottom: 16px;
  @media (max-width: 767px) {
    padding: 16px !important;
  }
  .hasError {
    .text-editor,
    input {
      border: 1px solid ${theme.colours.error} !important;
    }
  }
  .mantine-Checkbox-body {
    align-items: center;
    gap: 12px;
  }
  .mantine-Checkbox-inner {
    width: 12px;
    height: 12px;
  }
  .mantine-Checkbox-input {
    border-radius: 4px !important;
    border-color: ${theme.colours.blackText} !important;
    width: 12px;
    height: 12px;
    cursor: pointer;
    :checked {
      background-color: ${theme.colours.blackText} !important;
      border-color: ${theme.colours.blackText} !important;
    }
  }
  .custom_textarea {
    margin-bottom: 0 !important;
  }
  .desc {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    font-family: ${theme.fonts.Regular};
    color: #303030;
    span {
      color: #0c58db;
    }
  }
`;

export const Wrapper = styled.div`
  .hint {
    height: 25px;
    padding-top: 4px;
    padding-right: 8px;
    padding-bottom: 4px;
    padding-left: 8px;
    border-radius: 8px;
    background-color: #fff3cd;
    p {
      font-weight: 400;
      font-size: 13px;
      color: #856404;
      line-height: 17px;
    }
  }
  h2 {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    font-family: ${theme.fonts.Bold};
    color: ${theme.colours.blackText};
  }
  form {
    border-bottom: 0px !important;
    padding: 0px 0px 8px !important;
  }
  .desc {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    font-family: ${theme.fonts.Regular};
    color: ${theme.colours.black_2};
    width: 329px;
    text-align: center;
    @media (max-width: 768px) {
      padding: 0 16px;
    }
  }
  .disabled {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
  }
  .text-link {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    font-family: ${theme.fonts.Regular};
    color: ${theme.colours.NewCar};
    border: none;
    background: none;
    display: flex;
    align-items: center;
    gap: 4px;
    height: 24px;
    cursor: pointer;
    &:hover {
      background: none;
    }
  }
  .max-prosedure {
    font-size: 11px;
    font-weight: 400;
    line-height: 17px;
    font-family: ${theme.fonts.Regular};
    color: ${theme.colours.black_2};
  }

  .notSameAnswerWrapper {
    border-top: 1px solid rgb(200, 200, 200);
    padding-top: 8px;
    margin-top: 4px;
    p {
      font-size: 14px;
      font-weight: 600;
      line-height: 22px;
      font-family: ${theme.fonts.Bold};
      color: ${theme.colours.blackText};
    }
  }

  .route-modal-select-effect {
    width: 90px;
  }

  .question_container {
    list-style: none;
    margin-top: 16px;
    li.container {
      font-family: ${theme.fonts.Regular};
      min-height: 36px;
      height: 36px;
      border-radius: 8px;
      background: ${theme.colours.lightGray3};
      padding: 8px 16px;
      margin-bottom: 8px;
      color: ${theme.colours.textColor};
      &:last-child {
        margin-bottom: 0px !important;
      }

      h4 {
        color: ${theme.colours.blackText};
        font-size: 14px;
        font-weight: 400;
      }
      p {
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        height: 20px;
        max-width: fit-content;
        color: ${theme.colours.black_2};
        @media (max-width: 320.5px) {
          max-width: 185px !important;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      h3 {
        color: ${theme.colours.mainBlue};
        font-family: ${theme.fonts.Medium};
        font-size: 14px;
        cursor: pointer;
      }
      .question-actions {
        display: flex;
        align-items: center;
        gap: 16px;
      }
      svg.delete {
        font-size: 20px;
        color: ${theme.colours.SpanishGray};
        cursor: pointer;
      }
      ul.answers {
        list-style: none;
        li {
          p {
            color: ${theme.colours.BrightGray2};
            font-size: 14px;
          }
        }
      }
      ul.choices {
        list-style: none;
        &:lang(ar) {
          margin-right: 2px;
        }
        &:lang(en) {
          margin-left: 8px;
        }
        li {
          p {
            color: ${theme.colours.mainBlue};
          }
          position: relative;
          font-size: 14px;
          &:lang(ar) {
            margin-right: 16px;
            &::before {
              right: -10px;
            }
          }
          &:lang(en) {
            &::before {
              left: -10px;
            }
          }
          &::before {
            position: absolute;
            content: '•';
            color: ${theme.colours.mainBlue};
            font-size: 20px;
            top: 11px;
            transform: translateY(-50%);
          }
        }
      }
    }
  }
  button {
    &:hover {
      background-color: #242424;
    }
  }
`;

export const RouteModalWrapper = styled.div`
  .hasError {
    input,
    .mantine-Select-input,
    .mantine-DateInput-input,
    textarea {
      border: 1px solid ${theme.colours.error} !important;
    }
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;

  button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 16px;
    gap: 10px;
    width: 91px;
    min-width: 80px;
    height: 32px;
    background: #242424;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    font-family: ${theme.fonts.Regular};
    color: ${theme.colours.white};
    &.cancel_btn {
      background: ${theme.colours.white};
      color: ${theme.colours.blackText};
      border: 0.5px solid ${theme.colours.newOutline};
      width: 80px;
    }
  }
`;

export const WorkflowInfoWrapper = styled.div`
  h2 {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    font-family: ${theme.fonts.Bold};
    color: ${theme.colours.blackText};
  }

  label {
    p {
      margin-bottom: 0;
      line-height: 22px;
    }
  }
  .event-type-label {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #303030;
    padding-right: 12px;
  }

  .btn-date.mantine-Button-root {
    height: 32px !important;
    padding: 4px 12px !important;
    color: #000000 !important;
    justify-content: space-between !important;
    width: 100% !important;
    .mantine-Button-label {
      width: 100% !important;
    }
  }

  .mantine-Button-root {
    width: 100% !important;
    height: 28px !important;
    background-color: white !important;
    border: 0.5px solid ${theme.colours.newOutline} !important;
    padding: 9px 12px !important;
    border-radius: 8px !important;
  }

  .hasError {
    border: 1px solid ${theme.colours.error} !important;
  }
`;

export const RoutingWrapper = styled.div`
  border-top: 1px solid rgb(200, 200, 200);
  padding-top: 8px;
  h3 {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    color: ${theme.colours.blackText};
    font-family: ${theme.fonts.SemiBold};
  }
  .event-label {
    font-size: 13px;
    color: #000000;
    margin-bottom: 4px !important;
    padding-inline-start: 12px;
    display: inline-block;
    font-family: ${theme.fonts.Regular} !important;
    display: none;
    @media (max-width: 768px) {
      display: block;
    }
  }
  .link-container {
    input {
      direction: ltr;
    }
  }

  .hasError {
    .react-select__control {
      border: 1px solid ${theme.colours.error} !important;
    }
  }

  .input-wrapper {
    .label {
      p {
        display: none;
        @media (max-width: 768px) {
          display: block;
        }
      }
    }
  }

  .event-select {
    height: 32px;
    .react-select__value-container {
      height: 32px;
      text-align: right;
      &:lang(ar) {
        padding-left: 0;
      }
      &:lang(en) {
        padding-right: 0;
      }
    }
    .react-select__input-container {
      margin: -15px;
    }
    .react-select__single-value {
      span {
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .react-select__indicator {
      svg {
        width: 12.5px;
        margin-top: -3px;
        fill: #5d5d5e;
      }
    }
    .react-select__placeholder {
      margin-top: -6px;
      font-size: 14px;
      color: #000000;
    }
    .react-select__indicator-separator {
      display: none;
    }
    .react-select__control {
      height: 32px;
      min-height: 32px;
      border-radius: 8px;
      border: 1px solid #d4d4d4;
      text-align: right;
      box-shadow: none !important;
    }
  }
`;

export const RouteItemWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  gap: 16px;
  width: 568px;
  height: 36px;
  @media (max-width: 1199.5px) {
    width: 100% !important;
  }
  margin-bottom: 8px;

  background: #f5f5f5;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  transition: transform 0.3s ease-in-out;

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    font-family: ${theme.fonts.Regular};
    color: ${theme.colours.textColor};
    max-width: fit-content;
    @media (max-width: 500px) {
      max-width: 150px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    @media (max-width: 370px) {
      max-width: 100px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

export const mentionStyle = {
  control: {
    backgroundColor: '#fff',
    fontSize: 13,
    fontWeight: 'normal',
    borderRadius: 8,
  },

  '&multiLine': {
    control: {
      fontFamily: 'monospace',
      minHeight: 32,
    },
    highlighter: {
      border: '1px solid transparent',
    },
    input: {
      padding: 9,
      border: '1px solid silver',
      borderRadius: 8,
      outline: 'none',
    },
  },

  '&singleLine': {
    display: 'inline-block',
    width: '100%',

    highlighter: {
      padding: 1,
      border: '1px solid transparent',
    },
    input: {
      border: `1px solid ${theme.colours.newOutline}`,
      outline: 'none',
      backgroundColor: '#fff',
      fontSize: 13,
      fontWeight: 'normal',
      borderRadius: 8,
      marginTop: '6px',
      height: '32px',
      padding: '9px',
    },
  },

  suggestions: {
    width: '200px !important',
    minWidth: '200px !important',
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      borderRadius: 8,
      fontSize: 13,
      position: 'absolute',
      zIndex: 9999, // Increased z-index to appear above modal
      overflowY: 'auto',
      maxHeight: '250px',
      width: '200px !important',
      minWidth: '200px !important',
    },
    item: {
      padding: '5px 15px',
      '&focused': {
        backgroundColor: theme.colours.lightGray2,
      },
    },
  },
};
